"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTagSecondary: function() {
        return _index.InteractionTagSecondary;
    },
    interactionTagSecondaryClassNames: function() {
        return _index.interactionTagSecondaryClassNames;
    },
    renderInteractionTagSecondary_unstable: function() {
        return _index.renderInteractionTagSecondary_unstable;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return _index.useInteractionTagSecondaryStyles_unstable;
    },
    useInteractionTagSecondary_unstable: function() {
        return _index.useInteractionTagSecondary_unstable;
    }
});
const _index = require("./components/InteractionTagSecondary/index");
